// Hub principal: taller de palabras. Botón JUGAR como elemento central.
import { GAME_NAME } from '../core/Config.js';
import { avatarHTML } from './ProfileUI.js';
import { pwa } from '../core/PWA.js';
import { ICON } from './icons.js';
import { LOGO_SVG } from './logoMark.js';
// Logo antiguo (imagen). Se conserva por si hay que recuperarlo: descomenta y usa `logoUrl`.
// import logoUrl from '../assets/logo-tight.webp';

export class HubScreen {
  constructor(root, { progression, bus, onPlay, onTutorial, onOpen, onInstall }) {
    this.root = root;
    this.progression = progression;
    this.bus = bus;
    this.onPlay = onPlay;
    this.onTutorial = onTutorial;
    this.onOpen = onOpen;
    this.onInstall = onInstall;
    this.el = document.createElement('div');
    this.el.className = 'screen hub-screen hidden';
    this.el.setAttribute('role', 'main');
    this.root.appendChild(this.el);
    this._render();
  }

  _render() {
    const best = this.progression?.profile?.stats?.bestScore || 0;
    const prof = this.progression?.profile || {};
    const claimable = this.progression?.claimableCount?.() || 0; // logros por canjear (pin rojo)
    this.el.innerHTML = `
      <header class="hub-top">
        <div class="hub-top-left">
          <button class="hub-profile" data-open="profile" title="Editar tu perfil">
            <span class="hp-ava">${avatarHTML(prof)}</span>
            <span class="hp-name">${prof.name || 'Jugador'}</span>
            <span class="hp-edit">✏️</span>
          </button>
          <div class="hub-record" title="Mejor puntuación"><span class="rec-ic">${ICON.star}</span> <b>${best}</b></div>
        </div>
        <div class="hub-top-actions">
          ${pwa.installable() ? '<button class="btn btn-sm hub-install" data-install title="Instalar la app en tu dispositivo">⬇️ Instalar</button>' : ''}
          <div class="hub-icon-stack">
            <button class="icon-btn" data-open="settings" aria-label="Configuración" title="Ajustes">${ICON.gear}</button>
            <button class="icon-btn" data-open="friends" aria-label="Amigos" title="Amigos">${ICON.users}</button>
            <button class="icon-btn hub-ach-btn" data-open="achievements" aria-label="Logros" title="Logros">${ICON.trophy}${claimable > 0 ? '<span class="hub-pin" aria-label="Logros por canjear"></span>' : ''}</button>
            <button class="icon-btn" data-open="ranking" aria-label="Ranking" title="Ranking">${ICON.chart}</button>
          </div>
        </div>
      </header>

      <div class="hub-center hub-center-solo">
        ${LOGO_SVG}
        <!-- Logo antiguo (respaldo): <img class="hub-logo-img" src="\${logoUrl}" alt="${GAME_NAME}" draggable="false" /> -->
        <div class="hub-by">by <b>GAMEZ STUDIO</b></div>
        <div class="hub-cta">
          <button class="btn btn-cta btn-play" data-action="play"><span class="cta-label">JUGAR</span></button>
          <button class="btn btn-cta btn-howto" data-action="tutorial"><span class="cta-label">TUTORIAL</span></button>
        </div>
      </div>

      <footer class="hub-foot">${GAME_NAME} · v0.1 · ${typeof __APP_BUILD__ !== 'undefined' ? __APP_BUILD__ : 'dev'}</footer>
    `;

    this.el.querySelector('[data-action="play"]').addEventListener('click', () => this.onPlay());
    this.el.querySelector('[data-action="tutorial"]').addEventListener('click', () => this.onTutorial());
    this.el.querySelector('[data-install]')?.addEventListener('click', () => this.onInstall?.());
    this.el.querySelectorAll('[data-open]').forEach((n) => {
      const handler = () => this.onOpen(n.getAttribute('data-open'));
      n.addEventListener('click', handler);
      n.addEventListener('keydown', (e) => { if (e.key === 'Enter') handler(); });
    });
  }

  refresh() {
    this._render();
  }

  show() {
    this.refresh();
    this.el.classList.remove('hidden');
  }
  hide() {
    this.el.classList.add('hidden');
  }
}

